/*https://codekitapp.com/help/javascript/*/
// @codekit-prepend quiet "/node_modules/jquery/dist/jquery.js";
// @codekit-prepend quiet "/node_modules/foundation-sites/dist/js/foundation.js";

// @codekit-prepend quiet "character-count.js";
// @codekit-prepend quiet "button-prevent-double-click.js";
// @codekit-prepend quiet "/js/accessible-autocomplete-master/dist/accessible-autocomplete.min.js";


// JavaScript Document - 

$(document).foundation();

// Jquery
$('body').addClass('js-enabled');

function getAttrOrDefault(node, name, def) {
	var val = node.attr(name);
	return val != null ? val : def;
}


/* Step by Step */
var togglerReady = false;

$('#allSteps').on('click', function(e) {

	$(this).html($(this).html() == 'Show all' ? 'Hide all' : 'Show all');

	if(togglerReady == false) {

		var panels = $('.app-step-nav__panel:not(.expanded)');
		var buttons = $('.step-nav__button.singleStep[aria-expanded]').attr('aria-expanded', 'false');

		$(panels).foundation('toggle');
		$(buttons).html("Hide");

		togglerReady = true;

	} else {

		var panelsUpdated = $('.app-step-nav__panel.expanded');
		var buttonsUpdated = $('.step-nav__button.singleStep');

		$(panelsUpdated).foundation('toggle');
		$(buttonsUpdated).html("Show");

		togglerReady = false;

	}
	// reset the foundation toggler js component
	Foundation.reInit('toggler');

});


/* update the labels for the fondation toggler  */
$('.step-nav__button.singleStep').on('click', function(e) {

	var stepItem = $(e.currentTarget);
	var nextExpanded = $(this).attr('data-parent');



	if(stepItem.attr('aria-expanded') === 'true') {

		$(this).html('Show');

	} else {

		$(this).html('Hide');

	}

	if(stepItem.attr('aria-expanded') === 'false') {

		$(this).html('Hide');

		// improved focus 
		console.log('lets scroll to ' + nextExpanded)


		$('html,body').animate({
			scrollTop: $(nextExpanded).offset().top
		}, 'slow');


	} else {

		$(this).html('Show');

	}


	var buttonsCount = $('#allStepsListed > li .app-step-nav__panel.expanded').length;
	console.log('I count ' + buttonsCount + ' expanded panel step');

	// reset the Show / Hide all 
	if(buttonsCount < 2) {

		console.log('Less than 2 panels open so lets reset')

		$('#allSteps').html('Show all');

		// reset the foundation toggler js component
		Foundation.reInit('toggler');

		togglerReady = false;

	}


	if(buttonsCount > 4) {

		console.log('More than 4 panels open so lets reset')

		$('#allSteps').html('Hide all');

		// reset the foundation toggler js component
		Foundation.reInit('toggler');

		togglerReady = true;

	}

});